export const ROUTE_TITLES = {
  default: 'Verwaltung',
  home: 'Verwaltung',
  users: 'Verwaltung | Nutzer Liste',
  user: 'Verwaltung | Nutzer',
  groups: 'Verwaltung | Gruppen Liste',
  group: 'Verwaltung | Gruppe',
  group_users: 'Verwaltung | Gruppe Mitglieder',
  group_apps: 'Verwaltung | Gruppe Anwendungen',
  group_systems: 'Verwaltung | Gruppe Systeme',
  systems: 'Verwaltung | Systeme Liste',
  system: 'Verwaltung | System',
  accountSettings: 'Verwaltung | Einstellungen',
  accountSettingsExtended: 'Verwaltung | Einstellungen Erweitert',
  multiDomainMgmt: 'Verwaltung | Organisationen'
};
